import { Component } from "@angular/core";
import { OurServicesComponent } from "../../shared/components/our-services/our-services.component";
import { Newsletter } from "../../shared/components/newsletter/newsletter";
import { EventPopup } from "../../shared/components/event-popup/event-popup";
import { PartnersComponent } from "../../shared/components/partners/partners.component";
import { CtaSectionComponent } from "../cta-section/cta-section.component";
import { AboutUsComponent } from "../../shared/components/about-us/about-us.component";

@Component({
  selector: "app-home",
  imports: [
    OurServicesComponent,
    Newsletter,
    EventPopup,
    PartnersComponent,
    CtaSectionComponent,
    AboutUsComponent
  ],
  templateUrl: "./home.component.html",
  styleUrl: "./home.component.css",
  standalone: true,
})
export default class HomeComponent {
  showPopup = false;

  ngOnInit() {
    const alreadySeen = localStorage.getItem("event-popup-seen");
    if (!alreadySeen) {
      this.showPopup = true;
    }
  }


  closePopup() {
    this.showPopup = false;
    localStorage.setItem("event-popup-seen", "true");
  }

  scrollToContact() {
    const contactSection = document.getElementById("contact-form-section");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

}
